import { render, staticRenderFns } from "./post-edit.vue?vue&type=template&id=537fb368&scoped=true&"
import script from "./post-edit.vue?vue&type=script&lang=js&"
export * from "./post-edit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=537fb368&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537fb368",
  null
  
)

component.options.__file = "post-edit.vue"
export default component.exports